import { requestApi } from "../funcitons";

export const ScheduledEventsQueries = {
    getByScheduleCellId: async (scheduleCellId) => {
        const response = await requestApi(`cells/scheduled/${scheduleCellId}/events`, 'GET');
        return response.data;
    },
    createEvent: async (event) => {
        const response = await requestApi(`cells/scheduled`, 'POST', event);
        return response.data;
    },
    updateEvent: async (eventId, event) => {
        const response = await requestApi(`cells/scheduled/${eventId}`, 'PUT', event);
        return response.data;
    },
    deleteEvent: async (eventId) => {
        const response = await requestApi(`cells/scheduled/${eventId}`, 'DELETE');
        return response.data;
    },
}